import { useEffect } from "react";
import { observer } from "mobx-react-lite";

import { useAuthStore } from "@/features/auth";
import { useCompanyStore } from "../hooks";
import CompanySetupWizard from "../components/CompanySetupWizard";

const CompanySetupPage = observer((props = {}) => {
  const {
    isDialog = false,
    companyData: companyDataOverride,
    onCompleted,
    compact: compactOverride,
    showTargetFrequency = false,
  } = props;
  const hasCompanyIdOverride = Object.prototype.hasOwnProperty.call(
    props,

    "companyId",
  );
  const hasCompanyDataOverride = Object.prototype.hasOwnProperty.call(
    props,
    "companyData",
  );
  const { user } = useAuthStore();
  const { fetchCompany, company, setCompany, syncDraftOwner } =
    useCompanyStore();

  const userId = user?.userId ?? user?.id ?? user?._id ?? user?.email ?? null;
  const companyId = hasCompanyIdOverride
    ? props.companyId
    : (user?.companyId ?? null);
  const companyData = hasCompanyDataOverride ? companyDataOverride : company;

  useEffect(() => {
    syncDraftOwner(userId);
  }, [syncDraftOwner, userId]);

  useEffect(() => {
    if (companyDataOverride) return;

    if (!companyId) {
      setCompany(null);
      return;
    }
    fetchCompany({ companyId, force: true });
  }, [companyDataOverride, companyId, fetchCompany, setCompany]);

  const hasCompanyData = Boolean(companyId);
  const compact = compactOverride ?? !hasCompanyData;
  const containerClassName = hasCompanyData
    ? "flex w-full"
    : "flex w-full items-center justify-center py-6";

  return (
    <div
      className={
        hasCompanyData ? "flex w-full flex-col gap-6" : containerClassName
      }
    >
      <CompanySetupWizard
        isDialog={isDialog}
        compact={compact}
        companyId={companyId}
        companyData={companyData}
        showTargetFrequency={showTargetFrequency}
        onCompleted={onCompleted}
      />
    </div>
  );
});

export default CompanySetupPage;
